import { Link } from "react-router-dom";
import { primaryNavigation, inquiryNavigation } from "../siteNavigation";

export default function GlobalFooter() {
  return (
    <footer className="studio-footer w-full px-6 py-14 text-sm text-[#ede7dc]">
      <div className="max-w-7xl mx-auto grid gap-12 lg:grid-cols-[1.2fr_1fr]">
        <div>
          <h2 className="font-serif text-3xl mb-4">Make yourself at home.</h2>
          <p className="max-w-xl text-[#cfc6b7]">
            Saunter Haus creates interiors, staged homes, and furniture plans with an eye for texture,
            proportion, and pieces that feel collected over time.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-8">
          <div>
            <h3 className="font-semibold mb-3 uppercase tracking-[0.14em] text-xs">Explore</h3>
            <ul className="space-y-2 text-[#cfc6b7]">
              {primaryNavigation.map((item) => <li key={item.label}><Link to={item.href} className="hover:underline">{item.label}</Link></li>)}
            </ul>
          </div>
          <div>
            <h3 className="font-semibold mb-3 uppercase tracking-[0.14em] text-xs">Contact</h3>
            <ul className="space-y-2 text-[#cfc6b7]">
              <li><Link to={inquiryNavigation.href} className="hover:underline">{inquiryNavigation.label}</Link></li>
              <li><a href="mailto:hello@saunterhaus.com" className="hover:underline">hello@saunterhaus.com</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-12 border-t border-[#393129] pt-6 text-xs text-[#a89f91]">
        © {new Date().getFullYear()} Saunter Haus. All Rights Reserved.
      </div>
    </footer>
  );
}
